//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import AQModal from "../../../../../components/Generics/AQModal/AQModal.vue";
import AQButton from "../../../../../components/Generics/AQButton/AQButton.vue";
import AQUploader from "../../../../../components/Generics/AQUploader/AQUploader.vue";
import AQInput from "../../../../../components/Generics/AQInput/AQInput.vue";

export default {
    components: {
        AQInput,
        AQModal,
        AQButton,
        AQUploader
    },
    data() {
        return {
            modal1: false,
            modal2: false,
            modal3: false,
            modal4: false,
            extensionToSend: "",
            extensionToSendSingle: ""
        };
    },

    computed: {},
    methods: {
        actionsDlg1($event) {
            // eslint-disable-next-line default-case
            switch ($event) {
                case "save":
                    alert("save");
                    break;
                case "close":
                case "escape":
                    this.modal1 = false;
                    break;
            }
        },
        actionsDlg2($event) {
            // eslint-disable-next-line default-case
            switch ($event) {
                case "save":
                    alert("save");
                    break;
                case "close":
                case "escape":
                    this.modal2 = false;
                    break;
            }
        },
        actionsDlg3($event) {
            // eslint-disable-next-line default-case
            switch ($event) {
                case "save":
                    alert("save");
                    break;
                case "close":
                case "escape":
                    this.modal3 = false;
                    break;
            }
        },
        actionsDlg4($event) {
            // eslint-disable-next-line default-case
            switch ($event) {
                case "save":
                    alert("save");
                    break;
                case "close":
                case "escape":
                    this.modal4 = false;
                    break;
            }
        },

        uploadedData($event) {
            console.log("test view", $event);
        }
    }
};

